import { motion } from "framer-motion";
import { FiArrowRight, FiCheckCircle, FiZap } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const CTASection = () => {
  const { user, openRegister } = useAuth();
  return (
    <section className="section-white">
      <div className="container-main py-20 lg:py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 via-indigo-700 to-violet-700 p-10 sm:p-16 lg:p-20 text-center"
        >
          <div
            className="absolute inset-0 opacity-[0.06]"
            style={{
              backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
              backgroundSize: "28px 28px",
            }}
          />
          <div className="absolute -top-20 -right-20 w-80 h-80 bg-white/5 rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-white/5 rounded-full blur-3xl" />

          <div className="relative z-10 max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-white/15 border border-white/20 rounded-full px-4 py-1.5 mb-6">
              <FiZap size={13} className="text-yellow-300" />
              <span className="text-sm font-bold text-white">
                Free to submit
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white font-display leading-tight mb-4">
              Have a great website?
              <br />
              <span className="text-indigo-200">Share it with the world.</span>
            </h2>
            <p className="text-base sm:text-lg text-indigo-200/80 leading-relaxed mb-8 max-w-lg mx-auto">
              Submit your website to SiteVault. Get discovered by thousands of
              users and receive real community feedback.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              {user ? (
                <Link
                  to="/submit"
                  className="inline-flex items-center gap-2 bg-white text-indigo-700 font-extrabold px-8 py-3.5 rounded-xl hover:bg-indigo-50 transition-all shadow-xl shadow-black/10 active:scale-[0.98]"
                >
                  Submit Your Website <FiArrowRight size={16} />
                </Link>
              ) : (
                <button
                  onClick={openRegister}
                  className="inline-flex items-center gap-2 bg-white text-indigo-700 font-extrabold px-8 py-3.5 rounded-xl hover:bg-indigo-50 transition-all shadow-xl shadow-black/10 active:scale-[0.98]"
                >
                  Get Started Free <FiArrowRight size={16} />
                </button>
              )}
              <Link
                to="/categories"
                className="inline-flex items-center gap-2 text-indigo-200 hover:text-white font-semibold transition-colors"
              >
                Browse directory <FiArrowRight size={14} />
              </Link>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-5 mt-8">
              {["Free to submit", "Manually reviewed", "2–3 day approval"].map(
                (t) => (
                  <span
                    key={t}
                    className="flex items-center gap-1.5 text-sm text-indigo-200/70 font-medium"
                  >
                    <FiCheckCircle size={13} className="text-emerald-400" /> {t}
                  </span>
                ),
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
